module.exports = __webpack_public_path__ + "static/media/team.a1b38b09.jpeg";